import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Grid, List } from 'semantic-ui-react';
import moment from 'moment';

// Global Types
import { AppState } from 'services/types';
import {
    QuantitySchedule,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Components
import RoleButtonLink from 'components/RoleButtonLink';
import SemiBold from 'components/SemiBold';

// Global Selectors
// @ts-ignore
import {
    makeSelectHarvestQuantitySchedules,
    makeSelectHarvestEventScheduledQuantity
} from 'services/harvestEvents/selectors';

// Global Constants
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    scheduledQuantity?: number | null;
    quantitySchedules?: QuantitySchedule[];
}

type Props = OwnProps & ConnectedProps;

export class EventEntityTotalBins extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            harvestEventUuid,
            scheduledQuantity,
            quantitySchedules
        } = this.props;

        return (
            <Grid>
                <Grid.Column width={16}>
                    <List>
                        <List.Item>
                            <List.Content floated="right">
                                <RoleButtonLink
                                    requiredRoles={[
                                        ADMIN,
                                        MANAGER,
                                        ASSISTANT_MANAGER
                                    ]}
                                    params={{
                                        eventPrintModal: true,
                                        selectedEvent: harvestEventUuid,
                                        eventPopup: undefined,
                                        selectedGroup: undefined
                                    }}
                                    buttonProps={{
                                        primary: true
                                    }}
                                >
                                    Print
                                </RoleButtonLink>
                            </List.Content>
                            <List.Content>
                                <SemiBold>Daily Total</SemiBold>
                            </List.Content>
                        </List.Item>
                    </List>
                </Grid.Column>
                <Grid.Column width={16}>
                    <List>
                        {quantitySchedules &&
                            quantitySchedules.map(({ date, value }: any) => {
                                return (
                                    <List.Item key={date}>
                                        <List.Content floated="right">
                                            {value}
                                        </List.Content>
                                        <List.Content>
                                            {moment(date, 'YYYY-MM-DD').format(
                                                'ddd, DD MMM'
                                            )}
                                        </List.Content>
                                    </List.Item>
                                );
                            })}
                    </List>
                </Grid.Column>
                <Grid.Column width={16}>
                    <List>
                        <List.Item>
                            <List.Content floated="right">
                                {scheduledQuantity}
                            </List.Content>
                            <List.Content>TOTAL</List.Content>
                        </List.Item>
                    </List>
                </Grid.Column>
            </Grid>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    scheduledQuantity: makeSelectHarvestEventScheduledQuantity(),
    quantitySchedules: makeSelectHarvestQuantitySchedules()
});

export default connect(mapStateToProps)(EventEntityTotalBins);
